import { render, staticRenderFns } from "./AddObserveTask.vue?vue&type=template&id=7097228a&"
import script from "./AddObserveTask.vue?vue&type=script&lang=js&"
export * from "./AddObserveTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports